export const CUSTOM_EVENT_ERROR_PAGE_HIT = 'ErrorPageHit';
export const CUSTOM_EVENT_DATA_FULLY_LOADED_TIMEOUT = 'DataFullyLoadedTimeout';
export const CUSTOM_EVENT_CSS_LOAD_FAILURE = 'CSSLoadFailure';
export const MARK_NAME_VIEW_INITIAL_RENDER = 'viewInitialRender';
export const MARK_NAME_VIEW_DATA_FULLY_LOADED = 'viewDataFullyLoaded';
export const MARK_NAME_VIEW_CHANGED = 'viewChanged';
export const MARK_NAME_ERROR_PAGE_HIT = 'errorPageHit';
export const DATA_PROP_NAME_VIEW_INITIAL_RENDER = 'viewInitialRender';
export const DATA_PROP_NAME_VIEW_DATA_FULLY_LOADED = 'viewDataFullyLoaded';
// the timing difference between initial render and DFL
export const DATA_PROP_NAME_VIEW_IR_AND_DFL_DELTA = 'viewIRDFLDelta';
export const DATA_PROP_NAME_VIEW_DEPTH = 'viewDepth';
// for users we believe are authenticated, there are common api
// endpoints that are called for all authed routes.
// Future: there are more global marks to wait for like `accounts` but
// that's only true if `user` loads. We should not serialized requests
// without a data dependency need.
export const GLOBAL_DATA_MARKS_TO_WAIT_FOR_IF_AUTHED = ['user'];
export const DATA_PROP_FEATURE_NAME = 'featureName';
export const LISTENER_CLASS_FEATURE_LOAD_TIMING = 'featureLoadTimingListener';
export const LISTENER_CLASS_FEATURE_SPECIFIC_DFL = 'featureSpecificDFLListener';
//# sourceMappingURL=constants.js.map